export default function DownloadCTA() {
  return (
    <section id="download" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden bg-secondary-900">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20modern%20gradient%20with%20warm%20coral%20and%20soft%20rose%20tones%2C%20minimal%20geometric%20pattern%2C%20elegant%20background%2C%20cinematic%20widescreen&width=1400&height=500&seq=cta-bg-2026&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-30"
          />
          <div className="relative z-10 px-6 md:px-12 py-12 md:py-16 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
                随时随地，发现精彩
              </h2>
              <p className="text-background-50/70 text-sm md:text-base leading-relaxed mb-6 max-w-lg">
                下载紅桃視頻App，海量高清短视频等你来看。支持iOS和Android，完全免费，立即体验！
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <a
                  href="#"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-foreground-900 font-medium text-sm hover:bg-background-100 transition-colors duration-200"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </a>
                <a
                  href="#"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/15 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-colors duration-200 border border-background-50/25"
                >
                  <i className="ri-android-fill text-lg"></i>
                  安卓版下载
                </a>
              </div>
              <p className="text-background-50/40 text-xs mt-4">
                适用于 iOS 15+ 和 Android 8.0+ 设备
              </p>
            </div>
            <div className="flex-shrink-0">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-background-50/10 border border-background-50/20 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center rounded-2xl bg-primary-500">
                    <i className="ri-play-circle-fill text-background-50 text-3xl"></i>
                  </div>
                  <p className="text-background-50/70 text-xs">扫描二维码下载</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}